import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Tag,
  Col,
  ColorPicker,
  Button,
  Table,
  InputNumber,
  Checkbox,
  Tabs,
  Row,
  Divider,
} from 'antd';
import { useIntl } from 'react-intl';
import { StoreContext } from '../store/index';
import { getScore } from './utils';

function FinishModal({ shift, visible, onClose, onConfirm }) {
  const { formatMessage } = useIntl();
  const store = useContext(StoreContext);
  const {
    user: [user],
  } = store;

  const {
    startDate,
    placeName,
    address,
    placeSport,
    totalPlayers,
    localTeam,
    visitTeam,
    players,
  } = shift;

  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState([]);

  useEffect(() => {
    setStats([...players]);
  }, []);

  const onFinish = () => {
    onConfirm(stats);
    onClose();
  };
  const onFinishFailed = values => {};

  const updateGoalsByPlayer = (id, value) => {
    setStats(
      stats.map(p => ({
        ...p,
        goals: id === p.userId ? value : p.goals,
      })),
    );
  };
  const updateYellowCardsByPlayer = (id, value) => {
    setStats(
      stats.map(p => ({
        ...p,
        yellowCard: id === p.userId ? value : p.yellowCard,
      })),
    );
  };
  const updateRedCardsByPlayer = (id, value) => {
    setStats(
      stats.map(p => ({
        ...p,
        redCard: id === p.userId ? value : p.redCard,
      })),
    );
  };

  const updateAbsentByPlayer = (id, value) => {
    setStats(
      stats.map(p => ({
        ...p,
        absent: id === p.userId ? value : p.absent,
      })),
    );
  };

  const renderResume = local => (
    <Col xs={12}>
      {stats
        .filter(
          p =>
            p.isLocal === local &&
            (p.goals > 0 || p.yellowCard > 0 || p.redCard),
        )
        .map(item => (
          <Row style={{ marginTop: '4px' }} align="middle">
            <Col>{item.name}</Col>
            <Col offset={1}>
              <Row align="middle">
                {item.goals > 0 && '⚽'}
                {item.goals > 1 ? (
                  <p
                    style={{
                      marginRight: '2px',
                    }}>
                    {`x${item.goals} `}
                  </p>
                ) : (
                  <p style={{ marginLeft: '4px' }} />
                )}
                {item.yellowCard > 0 && (
                  <ColorPicker
                    style={{
                      marginRight: '4px',
                    }}
                    defaultValue="#FFF172"
                    disabled
                  />
                )}
                {item.yellowCard > 1 ? (
                  <p>{`x${item.yellowCard}`}</p>
                ) : (
                  <p style={{ marginLeft: '4px' }} />
                )}
                {item.redCard && (
                  <ColorPicker defaultValue="#FF0000" disabled />
                )}
              </Row>
            </Col>
          </Row>
        ))}
    </Col>
  );

  const columns = [
    {
      title: formatMessage({
        id: 'player.props.name',
      }),
      width: 100,
      align: 'center',
      dataIndex: 'name',
      key: 'name',
      sortDirections: ['descend', 'ascend'],
    },

    {
      title: formatMessage({
        id: 'player.props.goals',
      }),
      width: 80,
      align: 'center',
      dataIndex: 'goals',
      key: 'goals',
      render: (goals, player) => (
        <InputNumber
          style={{ maxWidth: '50px' }}
          size="small"
          defaultValue={player.goals}
          min={0}
          max={99}
          onChange={value => updateGoalsByPlayer(player.userId, value)}
        />
      ),
    },
    {
      title: <ColorPicker defaultValue="#FFF172" disabled />,
      width: 80,
      align: 'center',
      dataIndex: 'yerllowCards',
      key: 'yerllowCard',
      render: (yellowCards, player) => (
        <InputNumber
          style={{ maxWidth: '50px' }}
          size="small"
          defaultValue={player.yellowCard}
          min={0}
          max={2}
          onChange={value => updateYellowCardsByPlayer(player.userId, value)}
        />
      ),
    },
    {
      title: <ColorPicker defaultValue="#FF0000" disabled />,
      width: 60,
      align: 'center',
      dataIndex: 'redCard',
      key: 'redCard',
      render: (redCard, player) => (
        <Checkbox
          defaultChecked={player.redCard}
          onChange={e =>
            updateRedCardsByPlayer(player.userId, e.target.checked)
          }
        />
      ),
    },
    {
      title: formatMessage({
        id: 'player.props.absent',
      }),
      width: 40,
      align: 'center',
      dataIndex: 'absent',
      key: 'absent',
      render: (absent, player) => (
        <Checkbox
          defaultChecked={player.absent}
          onChange={e => updateAbsentByPlayer(player.userId, e.target.checked)}
        />
      ),
    },
  ];

  return (
    <Modal
      title={formatMessage({
        id: 'stats.title',
      })}
      open={visible}
      onOk={() => onFinish(stats)}
      okButtonProps={{ loading: loading }}
      onCancel={onClose}>
      <Tabs
        className="width100"
        items={[
          {
            key: 1,
            label: `${shift.localTeam.name}`,
            children: (
              <Table
                size="small"
                columns={columns}
                dataSource={[...stats.filter(({ isLocal }) => isLocal)]}
                scroll={{ x: 350 }}
                pagination={false}
              />
            ),
          },
          {
            key: 2,
            label: `${shift.visitTeam.name}`,
            children: (
              <Table
                size="small"
                columns={columns}
                dataSource={[...stats.filter(({ isLocal }) => !isLocal)]}
                scroll={{ x: 350 }}
                pagination={false}
              />
            ),
          },
          {
            key: 3,
            label: formatMessage({
              id: 'stats.resume',
            }),
            children: (
              <>
                <Row justify="center">
                  <h1>
                    {getScore(
                      stats,
                      shift.localTeam.name,
                      shift.visitTeam.name,
                    )}
                  </h1>
                </Row>
                <Row justify="space-between">
                  {renderResume(true)}
                  {renderResume(false)}
                </Row>
              </>
            ),
          },
        ]}
      />
    </Modal>
  );
}

export default FinishModal;

// TODO no se usa mas pero esta buena la tabla para reutilizar
